module.exports = __webpack_public_path__ + "static/fonts/Mont-Black.c0d37de.eot";